<template>
  <div>
    <ejs-grid ref='grid' :dataSource="data" height='100%' :allowReordering='true' :allowResizing='true'>
      <e-columns>
        <e-column field='groupid' :headerText='$t("MCS.groupNum")' width='150' textAlign='Center'></e-column>
        <e-column field='grouptype' clipMode='EllipsisWithTooltip' :valueAccessor='grouptypeFormatter' :headerText='$t("MCS.groupType")' width='150' textAlign='Center'></e-column>
        <e-column field='groupalias' clipMode='EllipsisWithTooltip' :headerText='$t("MCS.groupAlias")' width='150' textAlign='Center'></e-column>
        <e-column field='groupowner' clipMode='EllipsisWithTooltip' :headerText='$t("MCS.groupOwner")' width='150' textAlign='Center'></e-column>
      </e-columns>
    </ejs-grid>
    <ejs-pager ref='pager' @click='getGridData()' :pageSize='page.pageSize' :currentPage='page.pageNo' :totalRecordsCount='page.totalCount' ></ejs-pager>
  </div>
</template>

<script>
import commonJS from '../../common';

export default {
  name: 'GroupTableLayer',
  mixins: [commonJS],
  data() {
    return {
      data: {},
      info: '',
      userNumSearch: '',
      page: {
        pageNo: '1',
        pageSize: '100',
        totalCount: '0',
        pageCount: '0',
      },
    };
  },
  methods: {
    getGridData(ne = null, participantType = 0) {
      const $this = this;
      let vo;
      $this.info = ne;
      if (ne !== null && participantType === 0) {
        vo = {
          flag: 0,
          participantType: 0
        };
      } else {
        vo = {
          flag: 2,
          userNum: $this.userNumSearch,
          participantType: participantType
        };
      }
      const params = {
        info: $this.info,
        vo: vo,
        page: {
          pageNo: $this.$refs.pager.ej2Instances.currentPage,
          pageSize: this.page.pageSize
        }
      };
      console.log('params', params);
      this.$axios.post('/lte/ems/subscriber/mcs/requestCommon', params).then((response) => {
        const res = response.data;
        $this.data = res.resultVal.result === 0 ? [] : res.resultVal.result;
        $this.page.totalCount = res.countrsp;
      });
    },

    getClickData() {
      return this.$refs.grid.getSelectedRecords()[0];
    }
  },
};
</script>

<style scoped>

</style>
